// Step 1: Define a branded type for kebab case strings
export type KebabCaseString = string & { readonly brand: unique symbol };

// Step 2: Create a validation function for kebab case
export const isKebabCase = (value: string): value is KebabCaseString => {
	const kebabCaseRegex = /^[a-z]+(-[a-z]+)*$/;
	return kebabCaseRegex.test(value);
};
